module.exports = __webpack_public_path__ + "static/media/modifier-cercle.98171177.png";